export default "__VITE_ASSET__gbWR$p_e__"